/// <amd-module name="Build/Admin/PoolsList/Stores/SecurityPanelStore" />
import { Store } from "VSS/Reflux/Store";

export interface ISecurityPanelStoreState {
    isOpen: boolean;
}

export class SecurityPanelStore extends Store {
    public state: ISecurityPanelStoreState;

    constructor() {
        super("SecurityPanelStoreChanged");

        this.state = {
            isOpen: false
        };
    }

    public showPanel = () => {
        this.state = {
            isOpen: true
        };
        this.emitChanged();
    }

    public dismissPanel = () => {
        this.state = {
            isOpen: false
        };
        this.emitChanged();
    }
}
